[
  {
    "key": "elam",
    "name": "Elam",
    "adjective": "Elamite",
    "_leader": "Untash-Napirisha built the great walled city at Dur-Untash. Chosen over the obvious Elamite name, per ADR-0008.",
    "leader": "Untash-Napirisha",
    "_startingTechs": "Every civilisation begins knowing two technologies, chosen from what it was known for: Elam's clay tablets and temple rites, Nubia's bowmen and herds, Silla's stone and ritual, Carthage's hulls and amphorae, Tiwanaku's raised fields and stonework. They must be roots, or have their prerequisites in the same list.",
    "colour": "#E8C15A",
    "startingTechs": [
      "pottery",
      "ritual"
    ],
    "_personality": "The AI personality this civilisation leans to (personalities.json): Elam the builders of Dur-Untash, Nubia the archers, Silla the astronomers of Cheomseongdae, Carthage the traders, Tiwanaku the farmers who spread across the altiplano.",
    "personality": "builder",
    "cityNames": [
      "Susa",
      "Anshan",
      "Dur-Untash",
      "Madaktu",
      "Hidalu",
      "Kabnak",
      "Awan",
      "Simashki",
      "Adamdun",
      "Huhnur",
      "Liyan",
      "Zabshali"
    ],
    "description": "Highland and lowland bound into one kingdom, holding the passes between Mesopotamia and the plateau.",
    "traits": [
      "religious",
      "agricultural"
    ],
    "_traits": "Two traits each, from traits.json (ADR-0062), chosen from what the civilisation was known for. Each also has one unique unit (units.json, 'civilization')."
  },
  {
    "key": "nubia",
    "name": "Nubia",
    "adjective": "Nubian",
    "leader": "Amanirenas",
    "colour": "#C9633F",
    "startingTechs": [
      "woodworking",
      "husbandry"
    ],
    "personality": "militarist",
    "cityNames": [
      "Meroë",
      "Napata",
      "Kerma",
      "Qasr Ibrim",
      "Faras",
      "Dongola",
      "Sanam",
      "Kawa",
      "Pnubs",
      "Wad ban Naqa",
      "Musawwarat",
      "Gebel Barkal"
    ],
    "description": "Archers and ironworkers on the upper Nile, holding the trade of two worlds against every empire that came north.",
    "traits": [
      "militaristic",
      "expansionist"
    ]
  },
  {
    "key": "silla",
    "name": "Silla",
    "adjective": "Sillan",
    "leader": "Seondeok",
    "colour": "#5B8FD6",
    "startingTechs": [
      "stoneworking",
      "ritual"
    ],
    "personality": "scientist",
    "cityNames": [
      "Seorabeol",
      "Geumseong",
      "Ulsan",
      "Sabi",
      "Hanseong",
      "Gangneung",
      "Cheongju",
      "Sangju",
      "Jinju",
      "Miryang",
      "Yangju",
      "Namwon"
    ],
    "description": "A kingdom of astronomers and bone-rank aristocracy that outlasted both its rivals on the peninsula.",
    "traits": [
      "scientific",
      "religious"
    ]
  },
  {
    "key": "carthage",
    "name": "Carthage",
    "adjective": "Carthaginian",
    "leader": "Dido",
    "colour": "#BE5AA8",
    "startingTechs": [
      "woodworking",
      "pottery"
    ],
    "personality": "trader",
    "cityNames": [
      "Qart-Hadasht",
      "Utica",
      "Hadrumetum",
      "Hippo",
      "Panormus",
      "Gades",
      "Lilybaeum",
      "Leptis",
      "Motya",
      "Thapsus",
      "Sabratha",
      "Kerkouane"
    ],
    "description": "A sea power before it was a land one, holding the western Mediterranean by harbour, contract and credit.",
    "traits": [
      "seafaring",
      "commercial"
    ]
  },
  {
    "key": "tiwanaku",
    "name": "Tiwanaku",
    "adjective": "Tiwanakan",
    "leader": "Yamqui Supa",
    "colour": "#2FA58A",
    "startingTechs": [
      "agriculture",
      "stoneworking"
    ],
    "personality": "expansionist",
    "cityNames": [
      "Tiwanaku",
      "Lukurmata",
      "Pajchiri",
      "Khonkho Wankane",
      "Omo",
      "Chiripa",
      "Wankarani",
      "Iwawe",
      "Ojje",
      "Simillake",
      "Kala Uyuni",
      "Pariti"
    ],
    "description": "Raised-field farmers on the altiplano, who fed a city at four thousand metres where nothing should grow.",
    "traits": [
      "agricultural",
      "expansionist"
    ]
  },
  {
    "key": "aksum",
    "name": "Aksum",
    "adjective": "Aksumite",
    "leader": "Ezana",
    "colour": "#9A7DE0",
    "startingTechs": [
      "pottery",
      "ritual"
    ],
    "personality": "trader",
    "traits": [
      "commercial",
      "religious"
    ],
    "cityNames": [
      "Aksum",
      "Adulis",
      "Matara",
      "Yeha",
      "Qohaito",
      "Beta Samati",
      "Hawulti",
      "Keskese",
      "Ona Nagast",
      "Debre Damo",
      "Tokonda",
      "Addi Galamo"
    ],
    "description": "A Red Sea kingdom of obelisks and coinage, trading ivory and gold between Rome, Arabia and India."
  },
  {
    "key": "khmer",
    "name": "Khmer",
    "adjective": "Khmer",
    "leader": "Suryavarman II",
    "colour": "#94A83A",
    "startingTechs": [
      "agriculture",
      "stoneworking"
    ],
    "personality": "builder",
    "traits": [
      "scientific",
      "militaristic"
    ],
    "cityNames": [
      "Yasodharapura",
      "Hariharalaya",
      "Koh Ker",
      "Phimai",
      "Banteay Chhmar",
      "Sambor Prei Kuk",
      "Lopburi",
      "Phnom Rung",
      "Wat Phu",
      "Angkor Borei",
      "Mahendraparvata",
      "Preah Khan Kompong Svay"
    ],
    "description": "Builders of reservoirs and temple-mountains, ruling the Mekong plains from the greatest city of its age."
  },
  {
    "key": "rus",
    "name": "Kievan Rus'",
    "adjective": "Rus'",
    "leader": "Olga of Kiev",
    "colour": "#DB6F84",
    "startingTechs": [
      "woodworking",
      "husbandry"
    ],
    "personality": "militarist",
    "traits": [
      "militaristic",
      "commercial"
    ],
    "cityNames": [
      "Kiev",
      "Chernigov",
      "Pereyaslavl",
      "Novgorod",
      "Smolensk",
      "Polotsk",
      "Rostov",
      "Vladimir",
      "Turov",
      "Galich",
      "Ryazan",
      "Murom"
    ],
    "description": "River traders and warriors of the forest and steppe, from the Baltic to the Black Sea along the Dnieper."
  }
]
